/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_Wechat_TitleInputs */

const en_admin_settings_groups_wechat_title = /** @type {(inputs: Admin_Settings_Groups_Wechat_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WeChat Pay`)
};

const zh_admin_settings_groups_wechat_title = /** @type {(inputs: Admin_Settings_Groups_Wechat_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`微信支付`)
};

/**
* | output |
* | --- |
* | "WeChat Pay" |
*
* @param {Admin_Settings_Groups_Wechat_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_wechat_title = /** @type {((inputs?: Admin_Settings_Groups_Wechat_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_Wechat_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_groups_wechat_title(inputs)
	return zh_admin_settings_groups_wechat_title(inputs)
});
export { admin_settings_groups_wechat_title as "admin.settings.groups.wechat.title" }